import {setSessionToken} from "../configuration/cookiesConfig";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {APP_SALT, CLIENT_ID, ID_TOKEN} from "../../conf";
import {errorHandlerServices} from "../configuration/errorHandle";
import configAxios, {updateToken} from "../configuration/configAxios";
import {UserTokenInterface} from "../interface/UserTokenInterface";
import {getBooleanByParameter} from "../../utils/textOptions";
import {encryptPasswordBased} from "../../utils/decode/encryptionCrypto";
import {clearCookiesAndCache} from "../../utils/decode/getSessionByCookie";

export const decodeIdToken = (token: string | undefined): UserTokenInterface | null => {
    try {
        if (token) {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));

            return JSON.parse(jsonPayload);
        } else {
            return null
        }
    } catch (e) {
        clearCookiesAndCache();
        return null
    }
};

export function logoutSession(){
    clearCookiesAndCache();
    window.location.reload();
}

interface LoginProps {
    username: string,
    password: string
}

function setToken(tokenString: string) {
    const token = encryptPasswordBased(
        { access_token: tokenString },
        ID_TOKEN,
        APP_SALT
    );
    setSessionToken(ID_TOKEN, JSON.stringify({
        session: token.cipherText,
        key: token.iv
    }));
    updateToken(`${tokenString}`);
    return tokenString;
}

export const getTokenUser = async (data: LoginProps) => {
    if (getBooleanByParameter(process.env.REACT_APP_LOGIN_COGNITO)) {
        return await configAxios.post(`/cognito/`,
            {
                AuthFlow: 'USER_PASSWORD_AUTH', ClientId: CLIENT_ID,
                AuthParameters: { USERNAME: data.username, PASSWORD: data.password }
            },
            {
                baseURL: '',
                headers: {
                    'Content-Type': 'application/x-amz-json-1.1',
                    'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
                },
            }
        ).then(response => {
            return setToken(response.data.AuthenticationResult.IdToken);
        }).catch(error => {
            errorHandlerServices(error, false, undefined, true)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /api/auth/token`);
        })
    } else {
        return await configAxios.post(`/api/auth/token`,
            {...data, client_id: 'login-data-services', grant_type: 'password'},
            {
                baseURL: '',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            }
        ).then(response => {
            return setToken(response.data?.access_token);
        }).catch(error => {
            errorHandlerServices(error, false, undefined, true)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /api/auth/token`);
        })
    }
}


export const useCredentials = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: LoginProps) => getTokenUser(data),
    });
}
